import { googleAnalyticsConfig } from '../config';

// ----------------------------------------------------------------------

const setup = (...args) => {
  if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
    return;
  }
  if (!window.gtag) {
    return;
  }
  window.gtag(...args);
};

const track = {
  pageview: (props) => {
    setup('config', googleAnalyticsConfig, props);
  },
  event: (type, props) => {
    setup('event', type, props);
  }
};

export default track;
